import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Message, Button, Container } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { selectPriseEnChargeGrid } from "../../features/PriseEnCharge/PriseEnChargeSlice";

import axios from "axios";
import { server } from "../../App";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"

function DeletePriseEnCharge() {
  const [isdeleted, setIisdeleted] = useState(false);
  const PriseEnChargeState = useSelector(selectPriseEnChargeGrid);

  const { priseEnChargeData } = PriseEnChargeState;
  const {
    idPriseEnCharge,
    FK_id_Patient_Prise,
    civilite,
    NomPrenom,

    dateDeSoumission_Lisible,
  } = priseEnChargeData;

  sessionStorage.setItem("ID_PriseEnCharge", idPriseEnCharge);

  const deletehandler = async () => {
    await axios({
      method: "delete",
      responseType: "json",
      url: `${server}PriseEnCharge/${idPriseEnCharge}/${FK_id_Patient_Prise}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        // dispatch(form_load(initialState));
        toast.success("Success", {
          position: toast.POSITION.TOP_CENTER,
        });
        setIisdeleted(true);
      })
      .catch((err) =>
        toast.error("error", {
          position: toast.POSITION.TOP_CENTER,
        })
      );
  };

  return (
    <Fragment>
      <div className="heightFix">
        <br />
        <br />
        <br />
        <Container>
          {!isdeleted ? (
            <Message color="orange">
              <Message.Header>
                Voulez-vous supprimer la prise en charge de {civilite}{" "}
                {NomPrenom}, qui a été soumis le {dateDeSoumission_Lisible} ?{" "}
              </Message.Header>
            </Message>
          ) : (
            <Message color="green">
              <Message.Header>
                la prise en charge a été supprimé avec succès
              </Message.Header>
            </Message>
          )}
          {!isdeleted ?

            <Button
              floated="right"
              negative
              onClick={() => {
                deletehandler();
              }}
            >
              Supprimer
            </Button>
            :
            ""

          }

          <Link to="/PriseEnCharge">
            <Button floated="right" color="blue">
              retour
            </Button>
          </Link>
        </Container>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <SpeedDialComponent />
    </Fragment>
  );
}

export default DeletePriseEnCharge;
